import { useTheme } from '@automata/mui-theme';
import { DownloadButton, Typography } from '@automata/ui';
import CloudDownloadSharpIcon from '@mui/icons-material/CloudDownloadSharp';
import Stack from '@mui/material/Stack';

import { ChunkedJsonUploader } from './ChunkedJsonUploader';

type WorkflowInfo = { id: string; name: string };

type OverSizedJsonProps = {
  content: string;
  isEditable: boolean;
  jsonType: string;
  workflow: WorkflowInfo;
  onChange: (fileContent: string) => void;
};

export const OverSizedJson = ({
  content,
  isEditable,
  jsonType,
  workflow,
  onChange,
}: OverSizedJsonProps) => {
  const theme = useTheme();
  return (
    <Stack sx={{ mt: 1 }}>
      <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
        <CloudDownloadSharpIcon
          sx={{ fontSize: 30, color: theme.palette.primary[600] }}
        />
        <Typography variant="body1">Download JSON file</Typography>
      </Stack>

      <DownloadButton
        trackLabel={`wflow.${jsonType}.download`}
        fetchDownloadUrl={async () =>
          URL.createObjectURL(new Blob([content], { type: 'application/json' }))
        }
        data-testid={`download-file-input-${jsonType}`}
      >
        download {jsonType} json
      </DownloadButton>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap={1}
        width="100%"
      >
        <Stack direction="row" sx={{ width: '100%' }}>
          <ChunkedJsonUploader
            workflowInfo={workflow}
            isEditable={isEditable}
            onChange={onChange}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
